(ns shared.core.amelia-light.components.sheet
  (:require ["@up/base-ui/components/ui/sheet" :refer [Sheet SheetContent SheetHeader SheetTitle SheetDescription]]))

(defn up-sheet [& args] (into [:> Sheet] args))
(defn up-sheet-content [& args] (into [:> SheetContent] args))
(defn up-sheet-header [& args] (into [:> SheetHeader] args))
(defn up-sheet-title [& args] (into [:> SheetTitle] args))
(defn up-sheet-description [& args] (into [:> SheetDescription] args))
